angular.module("app").controller("ManageSkinGroupController", [
    '$scope',
    'errorHandler',
    'logger',
    '$uibModalInstance',
    'casinoGroupService',
    'skins',
    'groups',
    function ($scope, errorHandler, logger, $modalInstance, casinoGroupService, skins, groups) {
        $scope.attached = [];
        $scope.detached = [];

        $scope.selectedGroup = 0;
        $scope.newGroupName = '';
        $scope.fromGroupList = true;
        $scope.skinsList = skins.map(skin => ({id: skin.id, name: skin.name}));
        $scope.filteredSkinsList = [...$scope.skinsList]

        $scope.groupSkinsList = [];

        $scope.groupsList = [
            {
                id: 0,
                name: 'Choose a group'
            },
            ...groups
        ];


        $scope.filteredSkinsList.map(function (item) {
            item.checked = false;
        });

        $scope.addingItemsCount = $scope.groupSkinsList.length;
        $scope.addedItemsCount = $scope.filteredSkinsList.length;

        $scope.allQuery = "";
        $scope.existingQuery = "";
        $scope.state = {
            selectAllForAddModel: false,
            selectAllForRemoveModel: false
        };


        $scope.save = function () {
            $scope.isSavePressed = true;

            if (!$scope.fromGroupList && !$scope.newGroupName) {
                return;
            }

            if ($scope.fromGroupList && !$scope.selectedGroup) {
                return;
            }

            if ($scope.attached.length === 0 && $scope.detached.length === 0) {
                logger.logError("global.no_changes");
                return;
            }
            var switchSkinsForGroup = {
                attached: $scope.attached,
                detached: $scope.detached
            };

            if ($scope.fromGroupList) {
                switchSkinsForGroup.group_id = $scope.selectedGroup
            } else {
                switchSkinsForGroup.group_name = $scope.newGroupName
            }

            casinoGroupService.switchSkins({
                switchSkinsForGroup: {...switchSkinsForGroup}
            }).then(
                function (response) {
                    if (response.status === 'ok') {
                        logger.logSuccess("updated");
                        $modalInstance.close();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };
        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        $scope.addSelected = function () {
            var count = 0;
            var itemsToRemove = [];

            $scope.groupSkinsList.forEach(function (item, i) {
                if (item.checked) {
                    item.checked = false;
                    $scope.filteredSkinsList.push({
                        id: item.id,
                        name: item.name,
                        checked: false
                    });

                    itemsToRemove.push(i);

                    var detachedIndex = $scope.detached.indexOf(item.id);
                    if (detachedIndex === -1) {
                        $scope.attached.push(item.id);
                    } else {
                        $scope.detached.splice(detachedIndex, 1);
                    }
                    ++count;
                }
            });

            itemsToRemove.reverse().forEach(function (i) {
                $scope.groupSkinsList.splice(i, 1);
            });

            $scope.addedItemsCount += count;
            $scope.addingItemsCount -= count;

            $scope.state.selectAllForAddModel = false;
            $scope.$applyAsync();
        };
        $scope.removeSelected = function () {
            var count = 0;
            var itemsToRemove = [];

            $scope.filteredSkinsList.forEach(function (skin, i) {
                if (skin.checked) {
                    skin.checked = false;
                    $scope.groupSkinsList.push({
                        id: skin.id,
                        name: skin.name,
                        checked: false
                    });

                    itemsToRemove.push(i);

                    var attachedIndex = $scope.attached.indexOf(skin.id);
                    if (attachedIndex === -1) {
                        $scope.detached.push(skin.id);
                    } else {
                        $scope.attached.splice(attachedIndex, 1);
                    }
                    ++count;
                }
            });

            itemsToRemove.reverse().forEach(function (i) {
                $scope.filteredSkinsList.splice(i, 1);
            });
            $scope.addingItemsCount += count;
            $scope.addedItemsCount -= count;

            $scope.state.selectAllForRemoveModel = false;
        };
        $scope.filterForAdd = function (skin) {
            var item = getItemFromList($scope.allQuery, [skin]);
            return (item || item === null) && (!function () {
                for (var i = 0, length = $scope.filteredSkinsList.length; i < length; i++) {
                    if ($scope.filteredSkinsList[i].id === skin.id) {
                        return true
                    }
                }
                return false
            }())
        };
        $scope.filterForRemove = function (skin) {
            var item = getItemFromList($scope.allQuery, [skin]);
            return (item || item === null)
        };
        $scope.getSelectedForAddCount = function () {
            return $scope.groupSkinsList.reduce(function (prev, current) {
                return prev + (current.checked ? 1 : 0);
            }, 0)
        };
        $scope.getSelectedForDeleteCount = function () {
            return $scope.filteredSkinsList.reduce(function (prev, current) {
                return prev + (current.checked ? 1 : 0);
            }, 0)
        };

        /**
         * Select all for add
         */
        $scope.selectAllForAdd = function () {
            $scope.groupSkinsList.forEach(function (item) {
                if ($scope.filterForAdd(item)) {
                    item.checked = $scope.state.selectAllForAddModel;
                }
            });
        }

        /**
         * Select all for remove
         */
        $scope.selectAllForRemove = function () {
            $scope.filteredSkinsList.forEach(function (item) {
                if ($scope.filterForRemove(item)) {
                    item.checked = $scope.state.selectAllForRemoveModel;
                }
            });
        }
        /**
         * Recalculate counts of sections
         */
        $scope.recalculateCounts = function () {
            var count1 = 0;
            var count2 = 0;
            $scope.groupSkinsList.forEach(function (item) {
                if ($scope.filterForAdd(item)) {
                    ++count1;
                }
            });

            $scope.addedItemsCountaddingItemsCount = count1;

            $scope.filteredSkinsList.forEach(function (item) {
                if ($scope.filterForRemove(item)) {
                    ++count2;
                }
            });

            $scope.addedItemsCount = count2;
        };

        $scope.getCheckedItemsLength = function (items) {
            return items.filter(item => item.checked).length;
        };

        function getItemFromList(filterQuery, list) {
            if (!!filterQuery) {
                for (var i = 0, length = list.length, regex = new RegExp("^" + filterQuery); i < length; i++) {
                    if (list[i].name.toLowerCase().indexOf(filterQuery.toLowerCase()) !== -1 || regex.test(list[i].id)) {
                        return true
                    }
                }
            } else {
                return null
            }
            return false
        }

        function resetChanges() {
            $scope.filteredSkinsList = [...$scope.skinsList];
            $scope.groupSkinsList = [];
            $scope.addingItemsCount = 0;
            $scope.selectedGroup = 0;
            $scope.newGroupName = '';
            $scope.allQuery = '';

        }

        $scope.handleChange = function handleChange() {
            resetChanges()
            $scope.attached = [];
            $scope.detached = [];
        }

        $scope.handleGroupChange = function handleGroupChange(e) {
            if (!$scope.selectedGroup) {
                resetChanges()
            }

            $scope.attached = [];
            $scope.detached = [];

            casinoGroupService.getGroupSkinsList({group_id: $scope.selectedGroup}).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.groupSkinsList = angular.copy(response.casinoGroupSkinList)
                        $scope.addingItemsCount = $scope.groupSkinsList.length;

                        $scope.groupSkinsList.map(function (item) {
                            item.checked = false;
                        });

                        $scope.filteredSkinsList = [...$scope.skinsList];

                        $scope.filteredSkinsList = $scope.filteredSkinsList.filter(skin =>
                            !$scope.groupSkinsList.some(groupSkin => groupSkin.id === skin.id)
                        );
                    }

                    return null
                },
                function (response) {
                    errorHandler(response.message);
                    return null
                }
            )
        }
    }
]);